import { render, staticRenderFns } from "./return-line-item-data.vue?vue&type=template&id=c5b25936&scoped=true"
import script from "./return-line-item-data.vue?vue&type=script&lang=js"
export * from "./return-line-item-data.vue?vue&type=script&lang=js"
import style0 from "./return-line-item-data.vue?vue&type=style&index=0&id=c5b25936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b25936",
  null
  
)

export default component.exports